// 9fbef606107a605d69c0edbcd8029e5d
import SLP_CONSTANTS from './SearchDetail.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
};

const setAddToFavorite = (state, action) => {
  if (state.loadedProductsPages) {
    state.loadedProductsPages.forEach((products) => {
      products.forEach((item) => {
        if (
          item.miscInfo &&
          item.productInfo &&
          item.productInfo.generalProductId === action.payload.colorProductId
        ) {
          // eslint-disable-next-line no-param-reassign
          item.miscInfo = {
            ...item.miscInfo,
            isInDefaultWishlist: true,
            newItemId: action.payload.res && action.payload.res.newItemId,
            favoritedCount: action.payload.res && action.payload.res.favoritedCount,
          };
        }
      });
    });
  }
  return state;
};

const returnSearchDetailReducerExtension = (state = initialState, action) => {
  switch (action.type) {
    case SLP_CONSTANTS.SET_SLP_SCROLL_STATE:
      return {
        ...state,
        shouldSlpScroll: action.payload,
      };
    default:
      return { ...state };
  }
};
const mergeOrReplaceStateProducts = (state, action) => {
  if (action.payload.replace) {
    return {
      ...state,
      loadedProductsPages: [action.payload.loadedProductsPages[0]],
    };
  }
  return {
    ...state,
    loadedProductsPages: [...state.loadedProductsPages, action.payload.loadedProductsPages[0]],
  };
};

// eslint-disable-next-line complexity
const SearchDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SLP_CONSTANTS.SET_PRODUCTS:
      return mergeOrReplaceStateProducts(state, action);

    case SLP_CONSTANTS.SET_PAGE_WISE_PLP_PRODUCTS:
      return {
        ...state,
        loadedProductsPages: action.payload.loadedProductsPages[0],
        isFirstTimeLoad: false,
        totalProductsCount: action.payload.totalProductsCount,
      };

    case SLP_CONSTANTS.SET_SLP_FIRST_PRODUCTS_PAGE:
      return { ...state, ...action.productsPage, [DEFAULT_REDUCER_KEY]: setCacheTTL() };
    case SLP_CONSTANTS.SET_SLP_LOADING_STATE:
      return { ...state, ...action.payload };
    case SLP_CONSTANTS.SET_SLP_SEARCHTERM_STATE:
      return { ...state, ...action.payload };
    case SLP_CONSTANTS.SET_SLP_RESULTS_AVAILABLE_STATE:
      return { ...state, ...action.payload };
    case SLP_CONSTANTS.RESET_PRODUCTS:
      return initialState;
    case SLP_CONSTANTS.SET_N_SRP_FLAG:
      return { ...state, showProduct: action.payload, showRecent: !action.payload };
    case SLP_CONSTANTS.SET_CLICK_OUTSIDE_FLAG:
      return { ...state, showProduct: action.payload, showRecent: action.payload };
    case SLP_CONSTANTS.SET_ADD_TO_FAVORITE:
      setAddToFavorite(state, action);
      return { ...state };
    case SLP_CONSTANTS.SET_DEVICE_TIER:
      return {
        ...state,
        deviceTier: action.payload,
      };
    case SLP_CONSTANTS.REDIRECT_NULL_SEARCH_PAGE:
      return {
        ...state,
        loadedProductsPages: [],
        currentListingSearchForText: action?.payload?.enteredValue,
        searchResultSuggestions: action?.payload?.enteredText,
        oldSearchResultSuggestions: action?.payload?.searchedText,
      };
    case SLP_CONSTANTS.SET_ACROSS_BRAND_CALL:
      return {
        ...state,
        acrossBrandApiCalled: action.payload?.acrossBrandApiCalled,
        crossBrandProducts: action.payload?.crossBrandProducts,
        alternateBrandsShown: action.payload?.alternateBrandsShown,
      };
    case SLP_CONSTANTS.SCAN_COLOR_PRODUCT:
      return {
        ...state,
        colorProductId: action?.payload?.colorProductId,
      };
    case SLP_CONSTANTS.SET_BOPIS_FILTER_STATE_FOR_SLP:
      return { ...state, isBopisFilterOn: action.payload };
    default:
      return returnSearchDetailReducerExtension(state, action);
  }
};

export default SearchDetailReducer;
